import React from "react";
import "./style.css"; // Include your styles here or use a CSS-in-JS approach

const PricingCard = ({ title, price, period, features, isFeatured, style }) => {
  return (
    <div
      className={`pricing-item features-item ${isFeatured ? "pricing__item--featured" : ""}`}
      style={{ minHeight: "497px", ...style }}
    >
      <div
        className="pricing-deco"
        style={isFeatured ? { background: "linear-gradient(135deg,#a93bfe,#584efd)" } : {}}
      >
        <svg
          className="pricing-deco-img"
          enableBackground="new 0 0 300 100"
          height="100px"
          preserveAspectRatio="none"
          viewBox="0 0 300 100"
          width="300px"
        >
          <path
            className="deco-layer deco-layer--1"
            d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"
            fill="#FFFFFF"
            opacity="0.6"
          />
          <path
            className="deco-layer deco-layer--2"
            d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"
            fill="#FFFFFF"
            opacity="0.6"
          />
          <path
            className="deco-layer deco-layer--3"
            d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716H42.401L43.415,98.342z"
            fill="#FFFFFF"
            opacity="0.7"
          />
          <path
            className="deco-layer deco-layer--4"
            d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"
            fill="#FFFFFF"
          />
        </svg>
        <div className="pricing-price">
          <span className="pricing-currency"></span>
          {price}
          <span className="pricing-period"> {period}</span>
        </div>
        <h3 className="pricing-title">{title}</h3>
      </div>
      <ul className="pricing-feature-list">
        {features.map((feature, index) => (
          <li key={index} className="pricing-feature">
            {feature}
          </li>
        ))}
      </ul>
      <button className="pricing-action">Contact Us</button>
    </div>
  );
};

const Pricing = () => {
  const plans = [
    {
        title: "Basic",
        price: "₹19999",
        period: "",
      features: ["Upto 10 Pages", "Static Responsive Website", "1 Email Ids", "Contact Form", "Mobile Friendly", "Support 3 Months",  "Domain / Deployment: Additional Charges", "And More"],
    },
    {
      title: "",
      price: "Premium",
      period: "",
      features: ["Unlimited Pages", "Unique / Custom Design", "10 Email Ids on Demand", "Live Chat Integration", "Google Map Integration", "Support 10 Months",  "Domain / Deployment", "And More"],
      isFeatured: true,
    },
    {
      title: "E-Commerce",
      price: "₹64999",
      period: "",
      features: ["Upto 30 Products", "Multi Vendor Additional Charges", "3 Email Ids", "Contact Form", "Google Submission", "Support 5 Months",  "Domain / Deployment: Additional Charges", "And More"],
    },
  ];

  return (
    <div className="header">
      <div className="inner-header flex">
        <section>
          <center>
            <h1 style={{ fontSize: "2.5em", fontFamily: "'Open Sans', sans-serif", color: "white" }}>
              Choose a plan that's right for you
            </h1>
          </center>
          <div className="pricing pricing-palden">
            {plans.map((plan, index) => (
              <PricingCard key={index} {...plan} />
            ))}
          </div>
        </section>
      </div>
      <div>
        <svg
          className="waves"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g className="parallax">
            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Pricing;
